import React from 'react';
import { flagTypeHex } from './flagTypeColors';

// A multi-select of flag_type chips, colored the same as their badges elsewhere in the
// report — used both for the Flagged Threads tab's AND filter ("must have every selected
// flag") and the Agent Analysis tab's inclusion filter ("only chart these flags"); the two
// callers pass their own `label` since the selection semantics differ.
const FlagTypeFilter = ({ flagTypes, selected, onToggle, onClear, label }) => (
  <div className="flex flex-col gap-1.5">
    <div className="flex items-center gap-2">
      <span className="font-mono text-[10px] uppercase tracking-wider text-ink-mute">{label}</span>
      {selected.length > 0 && (
        <button type="button" onClick={onClear} className="text-[10px] text-ink-mute hover:text-ink underline">
          Clear
        </button>
      )}
    </div>
    <div className="flex flex-wrap gap-1.5">
      {flagTypes.map((ft) => {
        const isActive = selected.includes(ft);
        const hex = flagTypeHex(ft);
        return (
          <button
            key={ft}
            type="button"
            onClick={() => onToggle(ft)}
            style={isActive ? { backgroundColor: `${hex}33`, color: hex, borderColor: hex } : undefined}
            className={`rounded-full border px-2.5 py-0.5 text-xs font-bold transition-colors ${
              isActive ? '' : 'bg-surface-2 text-ink-dim border-white/10 hover:text-ink'
            }`}
          >
            {ft}
          </button>
        );
      })}
    </div>
  </div>
);

export default FlagTypeFilter;
